import { Box } from '@mui/material';
import React from 'react';
/**
 * @deprecated Replaced by `GlobalApp`. To control scrolling behavior, use `FullHeightPage`.
 * Do not use together with `GlobalApp` in new code.
 * @param {React.PropsWithChildren} props - React children to render within the header container.
 * @returns {React.ReactElement} The rendered legacy page header component.
 */
export const AppPageHeader = (props) => {
    return (React.createElement(Box, { sx: {
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            height: 84,
            paddingRight: 2,
            paddingLeft: 3,
            backgroundColor: (theme) => theme.palette.background.paper,
            borderBottom: (theme) => '1px solid ' + theme.palette.divider,
            overflow: 'hidden',
        } }, props.children));
};
